import { makeStyles } from '@material-ui/core/styles';

export const accountDetailsCss = makeStyles((theme) => ({
    brV1: {
        borderRadius: 8
    },
    dialogTitle: {
        padding: 24,
        paddingBottom: '0px !important',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingTop: 12
    },
    dialogContent: {
        padding: 24,
        paddingBottom: '0px !important'
    },
    textV1: {
        marginTop: 8,
        width: '100%',
        "& .MuiOutlinedInput-input": {
            textTransform: 'capitalize',
        },
    },
    titleV1: {
        fontSize: 12,
        color: 'grey',
        fontWeight: 300
    },
    mtV1: {
        marginTop: 16
    },
    disableCta: {
        width: '100%',
        paddingTop: 10,
        paddingBottom: 10,
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: 'lightgrey',
        fontSize: 15,
        fontWeight: 'bold',
        color: 'white !important',
        textTransform: 'capitalize',
        letterSpacing: '1px'
    },
    saveCta: {
        width: '100%',
        paddingTop: 10,
        paddingBottom: 10,
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: 'black',
        fontSize: 15,
        fontWeight: 'bold',
        color: 'white',
        textTransform: 'capitalize',
        letterSpacing: '1px',
        '&:hover': {
            backgroundColor: 'black',
        }
    },
    daV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 24
    },
    divV1: {
        fontSize: 22,
        fontWeight: 'bold',
        marginTop: 24,
        marginBottom: 30,
    },
    divAlign: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    checkV1: {
        '& .MuiFormControlLabel-label': {
            fontSize: 14
        },
        '& .MuiCheckbox-colorSecondary.Mui-checked': {
            color: '#0033cc !important'
        }
    },
    mtV2: {
        marginTop: 12
    },
    paperWidthV1: {
        maxWidth: 432
    },
    pV1: {
        marginLeft: '-9px'
    }
}));